'use client';
import {useRouter} from 'next/navigation';
import {createContext, useContext, useState, useEffect} from 'react';
import {getUserDataFromCookie, refreshUserDataFunc} from '@/libs/account/userData';
import Logout from '@/libs/account/logout';

const AuthContext = createContext();

export function AuthProvider({children}) {
	const router = useRouter();
	const [user, userSet] = useState(null);
	const [isLoading, isLoadingSet] = useState(true);

	useEffect(() => {
		async function syncLogin() {
			const data = await getUserDataFromCookie();
	
			if (data?.status === 'success' && data?.data?.userData?.contactID !== '') {
				userSet(() => data);
			} else {
				let dataLocalStorage = null;
				const sessionData = localStorage.getItem('SU_session');
				if (sessionData) {
					try {
						dataLocalStorage = JSON.parse(atob(sessionData));
					} catch (error) {
						console.error('Error parsing session data:', error);
						dataLocalStorage = null;
					}
				}
	
				if (dataLocalStorage?.data?.status === 'authorized') {
					userSet(() => dataLocalStorage);
				} else {
					userSet(() => null);
				}
			}
			isLoadingSet(() => false);
		}
	
		syncLogin();
	}, []);

	/* OLD function with issue when JSON.parse was null
	useEffect(() => {
		async function syncLogin() {
			let dataLocalStorage = null;
			const data = await getUserDataFromCookie();
			if (data?.status === 'success' && data?.data?.userData?.contactID !== '') {
				userSet(() => data);
			} else {
				const dataLocalStorage = (() => {
					const sessionData = localStorage.getItem('SU_session');
					return sessionData ? JSON.parse(atob(sessionData)) : null;
				})();
				dataLocalStorage = JSON.parse(atob(localStorage.getItem('SU_session')));
				if (dataLocalStorage?.data?.status === 'authorized') {
					userSet(() => dataLocalStorage);
				} else {
					userSet(() => null);
				}
			}
			isLoadingSet(() => false);
		}
		syncLogin();
	}, []);

	*/

	const login = async () => {
		try {
			let dataLocalStorage = null;
			const authUserData = await getUserDataFromCookie();
			if (authUserData?.status === 'success' && authUserData?.data?.userData?.contactID !== '') {
				userSet(() => authUserData);
			} else {
				dataLocalStorage = JSON.parse(atob(localStorage.getItem('SU_session')));
				if (dataLocalStorage?.data?.status === 'authorized') {
					userSet(() => dataLocalStorage);
				} else {
					userSet(() => null);
					throw new Error('Login/Get User Data From Cookie failed');
				}
			}

			isLoadingSet(() => false);
			return authUserData?.data?.userData?.contactID ? authUserData : dataLocalStorage;
		} catch (error) {
			userSet(() => null);
			isLoadingSet(() => false);
			return {status: 'error', message: error || 'Login error'};
		}
	};

	const logout = async () => {
		const returned_data = await Logout();
		userSet(null);
		if (returned_data?.status === 'success') router.push('/account/login');
	};

	const refreshUserData = async () => {
		const returned_data = await refreshUserDataFunc(user?.data?.userData?.contactID);
		let status = 'error';
		if (returned_data.status !== 'error') {
			userSet(() => returned_data);
			status = 'success';
		} else {
			status = 'error';
		}
		return {module: 'AuthContext - refresh user data', status, message: returned_data.message};
	};

	return <AuthContext.Provider value={{user, isLoading, login, logout, refreshUserData}}>{children}</AuthContext.Provider>;
}

export function useAuth() {
	return useContext(AuthContext);
}
